<template>
  <section>
    <form method="post" @submit.prevent="onSend">
      <form-wrapper :validator="$v.form">
        <form-group horizontal name="title" :label="$t('attributes.topic')">
          <b-input
            v-model="form.title"
            name="title"
            :placeholder="$t('message.please_input') + $t('attributes.title')"
            expanded
          ></b-input>
        </form-group>
        <form-group
          horizontal
          name="status"
          attribute="attributes.status"
          :label="$t('attributes.status')"
        >
          <b-switch v-model="form.status" name="status"></b-switch>
        </form-group>
        <form-group
          horizontal
          name="picture"
          attribute="attributes.picture"
          :label="$t('attributes.picture')"
          grouped
        >
          <template #label>
            {{ $t('attributes.picture') }}
            <b-tooltip type="is-dark" label="640*400/限定jpg檔，100KB內">
              <b-icon
                size="is-small"
                type="is-danger"
                icon="help-circle-outline"
              ></b-icon>
            </b-tooltip>
          </template>
          <b-field class="file">
            <a class="button is-primary" @click="onSelectPictureImage">
              <b-icon icon="upload"></b-icon>
              <span>{{ $t('message.please_select_file') }}</span>
            </a>
            <p
              v-if="form.picture"
              class="tag is-warning"
              style="margin-left: 4px; height: 40px"
            >
              <a
                :href="CatalogBannerImage(form.picture)"
                @click.prevent="onClickImage(CatalogBannerImage(form.picture))"
              >
                {{ form.picture }}
              </a>
            </p>
          </b-field>
        </form-group>
        <form-group horizontal name="url" :label="$t('attributes.url')">
          <b-input v-model="form.url" name="url" expanded></b-input>
        </form-group>
        <form-group
          horizontal
          name="description"
          :label="$t('attributes.description')"
        >
          <b-input
            v-model="form.description"
            name="description"
            type="textarea"
            expanded
          >
          </b-input>
        </form-group>
        <form-group
          horizontal
          name="selected_catalog"
          :label="$t('attributes.selected_catalogs')"
        >
          <div class="catalog-select-wrap-all mt-0">
            <div
              v-for="option in postCatalogs"
              :key="option.catalog_no"
              class="column is-3 is-marginless is-selectable catalog-select-tag"
            >
              <b-tag
                attached
                closable
                aria-close-label="Close tag"
                size="is-medium"
                @close="
                  onRemoveSelectedCatalogs(option, form.selected_catalogs)
                "
              >
                {{ !option.status ? '[下架]' : '' }}
                {{ option.name }}
              </b-tag>
            </div>
          </div>
        </form-group>
        <form-group horizontal name="area" :label="$t('attributes.area')">
          <b-select
            v-model="selectedArea"
            name="area_code"
            :loading="loadingAreas"
            :placeholder="$t('message.please_select') + $t('attributes.area')"
            @input="onSelectArea"
            expanded
          >
            <option :value="null" disabled>
              {{ $t('message.please_select') + $t('attributes.area') }}
            </option>
            <option v-for="option in areas" :key="option.code" :value="option">
              {{ option.name }}
            </option>
          </b-select>
        </form-group>
        <form-group horizontal name="catalog" :label="$t('attributes.catalog')">
          <div class="catalog-select-wrap">
            <div class="columns is-multiline is-mobile">
              <b-checkbox
                v-if="catalogsList.length > 0"
                v-model="showOffCatalogs"
                class="column is-3 is-marginless"
                @input="onShowOffCatalogs"
              >
                {{ $t('attributes.show_off_items') }}
              </b-checkbox>
            </div>
            <div class="columns is-multiline is-mobile">
              <b-checkbox
                v-for="option in catalogsList"
                v-model="form.selected_catalogs"
                :key="option.catalog_no"
                :native-value="option"
                :disabled="
                  form.selected_catalogs.findIndex(
                    c => c.catalog_no === option.catalog_no
                  ) !== -1
                "
                class="column is-3 is-marginless is-selectable"
                @input="selected => onSelectedCatalog(option, selected)"
              >
                {{ !option.status ? '[下架]' : '' }}
                {{ option.name }}
                <a
                  @click.prevent.stop="onUpdateSort(option)"
                  style="font-size: 14px; color: blue;"
                >
                  {{ $t('attributes.sort') }}
                </a>
              </b-checkbox>
            </div>
          </div>
        </form-group>
        <b-field horizontal>
          <b-button
            :loading="sending"
            type="is-primary"
            native-type="submit"
            style="width: 100%; margin-top: 20px;"
          >
            {{ $t('attributes.update_data') }}
          </b-button>
        </b-field>
      </form-wrapper>
    </form>
    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="selectedImageUrl" alt="" />
      </p>
    </b-modal>
    <b-modal
      :active.sync="isTouristInfoSortModelActive"
      :can-cancel="false"
      full-screen
      has-modal-card
    >
      <catalog-tourist-infos-from
        :catalog-no="selectedCatalogNo"
        :catalog-name="selectedCatalogName"
      />
    </b-modal>
  </section>
</template>

<script>
import { maxLength, required } from 'vuelidate/lib/validators'
import { OpenCatalogTouristInfoFinder } from '@/utils/ckfinder'
import notifyService from '@/services/notifyService'
import CatalogTouristInfosFrom from '@/components/catalogs/CatalogTouristInfosFrom'
import { AREA_API } from '@/utils/apis'

export default {
  name: 'TouristInfoBasic',
  components: { CatalogTouristInfosFrom },
  props: {
    touristInfo: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      sending: false,
      loadingAreas: false,
      isImageModalActive: false,
      isTouristInfoSortModelActive: false,

      id: this.touristInfo.id,
      form: this.extractFormValues(this.touristInfo),
      areas: [],
      selectedImageUrl: '',
      selectedArea: null,
      catalogs: [],
      catalogsList: [],
      selectedCatalogNo: '',
      selectedCatalogName: '',
      postCatalogs: this.touristInfo.catalogs
        ? [...this.touristInfo.catalogs]
        : [],
      showOffCatalogs: false
    }
  },
  validations: {
    form: {
      id: { required },
      status: { required },
      title: { required, maxLength: maxLength(50) },
      url: { maxLength: maxLength(500) },
      picture: { required, maxLength: maxLength(500) },
      description: { required, maxLength: maxLength(200) },
      selected_catalogs: { required }
    }
  },
  watch: {
    touristInfo(newTouristInfo) {
      this.id = newTouristInfo.id
      this.postCatalogs = newTouristInfo.catalogs
        ? [...newTouristInfo.catalogs]
        : []
      this.form = this.extractFormValues(newTouristInfo)
      this.loadAreas()
    }
  },
  mounted() {
    this.loadAreas()
  },
  methods: {
    extractFormValues(data) {
      return {
        id: data.id,
        title: data.title,
        status: data.status,
        url: data.url,
        picture: data.picture,
        description: data.description,
        selected_catalogs: data.catalogs
      }
    },
    async loadAreas() {
      try {
        this.loadingAreas = true

        const res = await this.axios.get(AREA_API)
        this.areas = res.data.data.sort(a => a.sort)
      } catch (e) {
        notifyService.fetch_error('area', e)
      } finally {
        this.loadingAreas = false
        this.selectedArea = null
        this.catalogs = []
        this.catalogsList = []
      }
    },
    onSelectArea(option) {
      this.selectedArea = option && option
      if (this.selectedArea) {
        this.catalogs = this.selectedArea.catalogs
        this.catalogsList = this.showOffCatalogs
          ? this.catalogs
          : this.catalogs.filter(c => c.status === true)
      } else {
        this.catalogs = []
        this.catalogsList = []
      }
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = url
    },
    async onSelectPictureImage() {
      try {
        this.form.picture = await OpenCatalogTouristInfoFinder(null)
      } catch (e) {
        notifyService.error(e)
      }
    },
    onShowOffCatalogs(selected) {
      this.showOffCatalogs = !!selected
      this.catalogsList = this.showOffCatalogs
        ? this.catalogs
        : this.catalogs.filter(c => c.status === true)
    },
    onSelectedCatalog(catalog, selectedCatalogs) {
      let index = selectedCatalogs.findIndex(
        c => c.catalog_no === catalog.catalog_no
      )
      const selected = index !== -1

      index = this.postCatalogs.findIndex(
        c => c.catalog_no === catalog.catalog_no
      )
      if (index === -1) {
        this.postCatalogs = [...this.postCatalogs, catalog]
      }

      index = this.form.selected_catalogs.findIndex(
        z => z.catalog_no === catalog.catalog_no
      )
      if (selected) {
        if (index === -1) {
          this.form.selected_catalogs = [
            ...this.form.selected_catalogs,
            catalog
          ]
        }
      } else {
        if (index !== -1) {
          this.form.selected_catalogs.splice(index, 1)
        }
      }
    },
    onRemoveSelectedCatalogs(catalog, selectedCatalogs) {
      let index = selectedCatalogs.findIndex(
        c => c.catalog_no === catalog.catalog_no
      )
      selectedCatalogs.splice(index, 1)
      this.form.selected_catalogs = selectedCatalogs
      this.postCatalogs = selectedCatalogs
    },
    onUpdateSort(data) {
      this.selectedCatalogNo = data.catalog_no
      this.selectedCatalogName = data.name
      this.isTouristInfoSortModelActive = true
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }
      this.$emit('send', this.form)
    }
  }
}
</script>
